import { render, staticRenderFns } from "./NoTeamTab.vue?vue&type=template&id=679530d0"
import script from "./NoTeamTab.vue?vue&type=script&lang=js"
export * from "./NoTeamTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports